// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_ug-0";